import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=1796ce44&scoped=true&"
import script from "./AdminList.vue?vue&type=script&lang=ts&"
export * from "./AdminList.vue?vue&type=script&lang=ts&"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=1796ce44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1796ce44",
  null
  
)

export default component.exports